// react
// navigate
import { createSlice } from '@reduxjs/toolkit';
// formik
// @material-ui
// icons
// hooks
// @types
import { AxiosResponseModel } from '../../@types/base';
import { DashboardCountsModel, DashboardModel } from '../../@types/dashboard';
// redux
import { CONSTS } from './const';
import { dispatch } from '../store';
// routes
// components
// utils
import axios from '../../utils/axios';
// constants
import { HttpStatusCodes } from '../../constants/http-status-codes.enum';
import { ModulesResultModel, ModulesListModel } from '../../@types/modules';

// ----------------------------------------------------------------------

type ConstantsState = {
  modulesListError: boolean;
  isModulesListLoading: boolean;
  modulesList: ModulesListModel[];
};

const initialState: ConstantsState = {
  modulesListError: false,
  isModulesListLoading: false,
  modulesList: []
};

const slice = createSlice({
  name: 'modules',
  initialState,
  reducers: {
    // ----------------------------------------------------------------------
    // MODULES
    // ----------------------------------------------------------------------

    // START MODULES LIST LOADING
    startModulesListLoading(state) {
      state.isModulesListLoading = true;
    },

    // HAS ERROR MODULES LIST
    hasErrorModulesList(state, action) {
      state.isModulesListLoading = false;
      state.modulesListError = action.payload;
    },

    // GET ALL MODULES LIST
    getAllModulesSuccess(state, action) {
      state.isModulesListLoading = false;
      state.modulesList = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const {} = slice.actions;

// ----------------------------------------------------------------------
// LOCATIONTYPELIST

export async function getAllModulesWithReturn() {
  dispatch(slice.actions.startModulesListLoading());
  try {
    const response: AxiosResponseModel<ModulesResultModel> = await axios
      .get(CONSTS.MODULES_GET_GET_ALL_MODULES)
      .catch((error) => {
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    if (response && response.status === HttpStatusCodes.StatusSuccess) {
      dispatch(slice.actions.getAllModulesSuccess(response.data?.data));
    } else {
      dispatch(slice.actions.getAllModulesSuccess([]));
    }
    return response;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorModulesList(error));
    return error.response.data;
  }
}

// ----------------------------------------------------------------------
